import React from "react";

import GraphqlWrapper from "GraphQL/GraphqlWrapper";

import Table from "./Table";
import GridPropsQuery from "../lib/AgGrid/GridPropsQuery";

const ClientsApp = props => {
  return (
    <GraphqlWrapper>
      <GridPropsQuery
        render={({ contractCodes, currentUser }) => (
          <section className="client_section">
            <Table contractCodes={contractCodes} currentUser={currentUser} />
          </section>
        )}
      />
    </GraphqlWrapper>
  );
};

export default ClientsApp;
